import { ValueOf } from 'type-fest';

export type ISelectInfo = ValueOf<typeof SelectInfo>;

export const SelectInfo = {
  BUILDING_ETC: 'building_etc',
  BUILDING_ENTRY: 'building_entry',
  BUILDING_PARKING: 'building_parking',
  BUILDING_TRASH: 'building_trash',
};

interface ISubInfoItem {
  label: string;
  key: string;
}
export type SubInfo = ISubInfoItem[];

// 우선은 추가된 기획이 없으므로 고정된 구조로 설정
export const buildingInfoMeta = [
  {
    key: SelectInfo.BUILDING_ETC,
    label: '특이사항',
    subInfo: [
      { label: '필수사항', key: 'remark001' },
      { label: '보안수칙', key: 'remark002' },
    ],
    imgSrc: '/icons/catecory/building_etc.svg',
  },
  {
    key: SelectInfo.BUILDING_ENTRY,
    label: '진입정보',
    subInfo: [
      { label: '진입방법', key: 'entry001' },
      { label: '유의사항', key: 'entry002' },
    ],
    imgSrc: '/icons/catecory/building_key.svg',
  },
  {
    key: SelectInfo.BUILDING_PARKING,
    label: '주차장 정보',
    subInfo: [
      { label: '주차 환경', key: 'parking001' },
      { label: '유의사항', key: 'parking002' },
    ],
    imgSrc: '/icons/catecory/building_parking.svg',
  },
  {
    key: SelectInfo.BUILDING_TRASH,
    label: '쓰레기 배출 정보',
    subInfo: [
      { label: '배출 장소', key: 'garbage001' },
      { label: '유의사항', key: 'garbage002' },
    ],
    imgSrc: '/icons/catecory/building_trash.svg',
  },
];
